import React from 'react';
import { Text, InputTextArea } from '@brokerbay/design-components';
import { FeedbackInputProps } from '../types';

type FeedbackTextProps = FeedbackInputProps;

const FeedbackText: React.FC<FeedbackTextProps> = ({
  disabled,
  onChange,
  template: { options, response },
}) => {
  const _onChange = (ev: any) => {
    onChange(ev.currentTarget.value);
  };

  return (
    <InputTextArea disabled={disabled} value={response} onChange={_onChange} />
  );
};

export default FeedbackText;
